import ProcedureChecklistList from "@/components/Procedures/ProcedureChecklistList.vue";

const ProcedureRoutes = [
    {
        path: "/procedures",
        name: "ProcedureChecklistList",
        components: {
            page: ProcedureChecklistList
        }
    }
];

export default ProcedureRoutes;
